/**
 * The account settings side navigation, shared by every settings route
 * (overview/profile/privacy/notifications in `pages.tsx`, billing in
 * `billing-settings.tsx`). Adding a settings page = one entry here.
 */
import { localizedPath, useTranslation } from '../lib/i18n'
import type { TranslationKey } from '../lib/i18n/dictionary'
import type { RouteKey } from '../lib/i18n/routes'

const SETTINGS_LINKS: Array<{ route: RouteKey; label: TranslationKey }> = [
  { route: 'settingsProfile', label: 'pages.settings.navProfile' },
  { route: 'settingsBilling', label: 'pages.settings.navBilling' },
  { route: 'settingsPrivacy', label: 'pages.settings.navPrivacy' },
  { route: 'settingsNotifications', label: 'pages.settings.navNotifications' },
]

export function SettingsNav({ current }: { current?: RouteKey }) {
  const { locale, t } = useTranslation()
  return (
    <aside className="side-panel">
      {SETTINGS_LINKS.map((link) => (
        <a
          key={link.route}
          href={localizedPath(link.route, locale)}
          aria-current={current === link.route ? 'page' : undefined}
        >
          {t(link.label)}
        </a>
      ))}
    </aside>
  )
}
